import { useState } from "react";
import { Icon } from "../shared/Icons";
import { CATEGORIES } from "../../data/products";

export function ProductModal({ product, onSave, onClose }) {
  const blank = { name:"", price:"", qty:"", category:"Equipment", description:"", badge:"", image:null };
  const [form, setForm] = useState(
    product
      ? { ...product, price:String(product.price), qty:String(product.qty), badge:product.badge||"", image:product.image||null }
      : blank
  );
  const [loading, setLoading] = useState(false);
  const upd = (k, v) => setForm(f => ({ ...f, [k]:v }));
  const valid = form.name.trim() && +form.price > 0 && +form.qty >= 0;

  const handleSave = async () => {
    if (!valid || loading) return;
    setLoading(true);
    try {
      await onSave({ ...form, price:+form.price, qty:+form.qty, badge:form.badge||null });
    } finally {
      setLoading(false);
    }
  };

  const handleImageFile = e => {
    const file = e.target.files?.[0];
    if (!file || !file.type.startsWith("image/")) return;
    const reader = new FileReader();
    reader.onload = ev => {
      const img = new Image();
      img.src = ev.target.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const MAX_WIDTH = 800;
        let { width, height } = img;
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        upd("image", canvas.toDataURL("image/jpeg", 0.7)); // 70% quality JPEG is plenty for web
      };
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <h3>{product ? "Edit Product" : "Add New Product"}</h3>
          <button className="modal-close" onClick={onClose}><Icon name="x" size={14} /></button>
        </div>
        <div className="modal-body">
          <div className="form-field">
            <label>Product Name *</label>
            <input value={form.name} onChange={e => upd("name", e.target.value)} placeholder="e.g. Dental Scaler Pro" />
          </div>
          <div className="form-row">
            <div className="form-field">
              <label>Price (₹) *</label>
              <input type="number" value={form.price} onChange={e => upd("price", e.target.value)} placeholder="0" />
            </div>
            <div className="form-field">
              <label>Quantity *</label>
              <input type="number" value={form.qty} onChange={e => upd("qty", e.target.value)} placeholder="0" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field">
              <label>Category</label>
              <select value={form.category} onChange={e => upd("category", e.target.value)}>
                {CATEGORIES.map(c => <option key={c}>{c}</option>)}
              </select>
            </div>
            <div className="form-field">
              <label>Badge</label>
              <select value={form.badge} onChange={e => upd("badge", e.target.value || null)}>
                <option value="">None</option>
                {["Best Seller","New","Sale"].map(b => <option key={b}>{b}</option>)}
              </select>
            </div>
          </div>
          <div className="form-field">
            <label>Product Image</label>
            {form.image ? (
              <div>
                <img src={form.image} alt="Preview" className="img-upload-preview" />
                <div className="img-upload-actions">
                  <div className="img-upload-area" style={{ flex:1, padding:"9px 12px" }}>
                    <input type="file" accept="image/*" onChange={handleImageFile} />
                    <span style={{ fontSize:12, color:"var(--blue)", fontWeight:600, pointerEvents:"none" }}>
                      Replace image
                    </span>
                  </div>
                  <button className="btn btn-danger btn-sm" onClick={() => upd("image", null)}>
                    <Icon name="trash" size={12} /> Remove
                  </button>
                </div>
              </div>
            ) : (
              <div className="img-upload-area">
                <input type="file" accept="image/*" onChange={handleImageFile} />
                <div style={{ pointerEvents:"none" }}>
                  <Icon name="products" size={22} />
                  <div style={{ marginTop:6, fontSize:13, fontWeight:600, color:"var(--text2)" }}>Click to upload image</div>
                  <div className="img-upload-hint">PNG, JPG, WEBP supported</div>
                </div>
              </div>
            )}
          </div>
          <div className="form-field">
            <label>Description</label>
            <textarea
              value={form.description}
              onChange={e => upd("description", e.target.value)}
              placeholder="Product details and specifications…"
            />
          </div>
          <button
            className={`btn btn-primary ${loading ? "disabled" : ""}`}
            style={{ width:"100%", justifyContent:"center", marginTop:8, padding:"12px" }}
            disabled={!valid || loading}
            onClick={handleSave}
          >
            <Icon name={loading ? "clock" : (product ? "check" : "plus")} size={14} />
            {loading ? "Saving..." : (product ? "Save Changes" : "Add Product")}
          </button>
        </div>
      </div>
    </div>
  );
}
